import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useOpenShift } from "../hooks";
import { getCurrentPosition } from "@/shared/utils/location";
import { formatTimeInZone } from "../utils/formatShiftTime";

export function ShiftBanner() {
  const { data: openShift, isLoading } = useOpenShift();
  const navigate = useNavigate();
  const [isRequestingLocation, setIsRequestingLocation] = useState(false);

  const handleStartShift = async () => {
    setIsRequestingLocation(true);
    try {
      const location = await getCurrentPosition();
      navigate("/shifts/confirm-start", { state: { location } });
    } finally {
      setIsRequestingLocation(false);
    }
  };

  const handleEndShift = () => {
    navigate("/shifts/confirm-end");
  };

  if (isLoading) {
    return null; // Don't show anything while loading
  }

  // No open shift - show banner to start shift
  if (!openShift) {
    return (
      <div className="bg-blue-50 border-b border-blue-200 px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <Clock className="h-5 w-5 text-blue-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm text-blue-800">
                <span className="font-medium">You don't have an open shift.</span>
              </p>
            </div>
          </div>
          <Button
            onClick={handleStartShift}
            disabled={isRequestingLocation}
            size="sm"
            className="bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 rounded-lg shadow-sm transition-colors tap-highlight-transparent"
          >
            {isRequestingLocation ? "Getting location…" : "Start Shift"}
          </Button>
        </div>
      </div>
    );
  }

  // Has open shift - show options to add notes or end shift
  return (
    <>
      <div className="bg-green-50 border-b border-green-200 px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <Clock className="h-5 w-5 text-green-600" />
            </div>
            <div className="flex-1">
              <p className="text-sm text-green-800">
                <span className="font-medium">Shift in progress</span> since{" "}
                {formatTimeInZone(openShift.started_at, openShift.timezone)}
              </p>
            </div>
          </div>
          <Button
            onClick={handleEndShift}
            variant="outline"
            size="sm"
          >
            End Shift
          </Button>
        </div>
      </div>
    </>
  );
}

